var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUppload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 16,
    fill: "#F0FDF4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51 38.5V48.5C51 48.8315 50.8683 49.1495 50.6339 49.3839C50.3995 49.6183 50.0815 49.75 49.75 49.75H22.25C21.9185 49.75 21.6005 49.6183 21.3661 49.3839C21.1317 49.1495 21 48.8315 21 48.5V38.5C21 38.1685 21.1317 37.8505 21.3661 37.6161C21.6005 37.3817 21.9185 37.25 22.25 37.25C22.5815 37.25 22.8995 37.3817 23.1339 37.6161C23.3683 37.8505 23.5 38.1685 23.5 38.5V47.25H48.5V38.5C48.5 38.1685 48.6317 37.8505 48.8661 37.6161C49.1005 37.3817 49.4185 37.25 49.75 37.25C50.0815 37.25 50.3995 37.3817 50.6339 37.6161C50.8683 37.8505 51 38.1685 51 38.5ZM30.6344 28.1344L34.75 24.0172V38.5C34.75 38.8315 34.8817 39.1495 35.1161 39.3839C35.3505 39.6183 35.6685 39.75 36 39.75C36.3315 39.75 36.6495 39.6183 36.8839 39.3839C37.1183 39.1495 37.25 38.8315 37.25 38.5V24.0172L41.3656 28.1344C41.6002 28.3689 41.9183 28.5007 42.25 28.5007C42.5817 28.5007 42.8998 28.3689 43.1344 28.1344C43.3689 27.8998 43.5007 27.5817 43.5007 27.25C43.5007 26.9183 43.3689 26.6002 43.1344 26.3656L36.8844 20.1156C36.7683 19.9994 36.6304 19.9072 36.4787 19.8443C36.3269 19.7814 36.1643 19.749 36 19.749C35.8357 19.749 35.6731 19.7814 35.5213 19.8443C35.3696 19.9072 35.2317 19.9994 35.1156 20.1156L28.8656 26.3656C28.6311 26.6002 28.4993 26.9183 28.4993 27.25C28.4993 27.5817 28.6311 27.8998 28.8656 28.1344C29.1002 28.3689 29.4183 28.5007 29.75 28.5007C30.0817 28.5007 30.3998 28.3689 30.6344 28.1344Z",
    fill: "#166534"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUppload);
export default __webpack_public_path__ + "static/media/uppload.38576997829d735d8efb365935eaae39.svg";
export { ForwardRef as ReactComponent };